<template>
  <div class="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
    <div class="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
      <h2 class="text-xl font-bold mb-4 text-gray-800">Edit Staff</h2>
      <form @submit.prevent="submitStaff">
        <input v-model="localStaff.name" class="w-full p-2 border rounded-lg mb-4" placeholder="Name" required />
        <input v-model="localStaff.email" type="email" class="w-full p-2 border rounded-lg mb-4" placeholder="Email" required />
        <input v-model="localStaff.phone" type="phone" class="w-full p-2 border rounded-lg mb-4" placeholder="Phone" required />
        <button type="submit" class="w-full bg-green text-white p-2 rounded-lg">Update Staff</button>
      </form>
      <button @click="closeModal" class="mt-4 w-full text-gray-600">Cancel</button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    staff: {
    },
  },
  data() {
    return {
      localStaff: { ...this.staff}, // Create a local copy of the staff prop
    };
  },
  methods: {
    ...mapActions('staffs',{updateStaff : 'updateStaff'}),
    submitStaff() {
      this.$emit('editStaff', this.localStaff);
      this.updateStaff(this.localStaff);
      this.closeModal();
    },
    closeModal() {
      this.$emit('closeModal');
    },
  },
};
</script>
